export const environment = {
  production: true,
  msalConfig: {
    auth: {
      clientId: '1b41479e-e668-4ae6-814b-62a2ae5797ce',
      authority: 'https://login.microsoftonline.com/189de737-c93a-4f5a-8b68-6f4ca9941912/',
    },
  },
  apiConfig: {
    scopes: ['api://1ae46877-8120-425f-a4e7-b6a82e685467/Files.Read'],
    uri: 'https://mypcmapi.hcl.com/',
  },
  
  clientId: "1b41479e-e668-4ae6-814b-62a2ae5797ce", //MY_PCM
  authority: "https://login.microsoftonline.com/189de737-c93a-4f5a-8b68-6f4ca9941912/",
  validateAuthority: true,

  redirectUri: "https://mypcm.hcl.com/",
  postLogoutRedirectUri: "https://mypcm.hcl.com/",
  navigateToLoginRequestUrl: true,

  cacheLocation: "localStorage", 
  loginRequest: ["openid", "profile"],

  resourceUri: "https://mypcmapi.hcl.com/",
  resourceScope: "api://1ae46877-8120-425f-a4e7-b6a82e685467/Files.Read",
  
  BASE_API_URL : "https://mypcmapi.hcl.com/mypcm",
  cloud_API_URL:"https://mypcmapi.hcl.com/mypcm",
  serverLocation : "prod",
  customerId : 2 
  
};